import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';

const AgreementCompletePopup: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <Popup
      isOpen={store.isAgreementPopupOpen}
      mainBtn={{
        label: '확인',
        onClick: () => store.waitForAgreementPopup?.complete(true),
      }}
    >
      {{
        title: '약관 동의가 완료되었습니다.',
        description:
          '이전 프로모션에서 본인인증 정보 이용(선택)에 동의하신 고객님은 본인인증 절차를 생략합니다. 해당 선택동의 철회를 원하시는 경우 고객센터(1644-1346)로 연락주시기 바랍니다.',
      }}
    </Popup>
  );
};

export default observer(AgreementCompletePopup);
